<template>
<div class="chapter">
<div class="inner_page">
<p class="copy2"><a id="page_iv"></a>Copyright © 2009 by Ralph L. Bayrer</p>
<p class="copy">New Academia Publishing, 2010</p>
<p class="copy">All rights reserved. No part of this book may be reproduced or transmitted in any form or by any means, electronic or mechanical, including photocopying, recording, or by any information storage and retrieval system.</p>
<p class="copy">Library of Congress Control Number: 2009935178</p>
<p class="copy0">ISBN 978-0-9823867-4-3 paperback (alk. paper)</p>
<table>
<tbody><tr>
<td>
<p class="copyz"><img alt="image" src="images/f00iv-1.jpg"/></p>
</td>
<td>
<p class="copy0">New Academia Publishing, LLC</p>
<p class="copy0">P.O. Box 27420</p>
<p class="copy0">Washington, DC 20038-7420</p>
<p class="copy0"><span class="weblink"><a href="http://www.newacademia.com" target="_blank"><span class="underline">www.newacademia.com</span></a></span> - <span class="weblink"><a href="mailto:info@newacademia.com"><span class="underline">info@newacademia.com</span></a></span></p>
</td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_copyright.vue?41c34dc4